import { ls } from '@/utility';

export default {
  loading: false,
  sortKey: '',
  searchVal: '',
  stateFilters: {},
  filters: [], // basic table filters received from backend
  basicFilters: {}, // applied basic table filters
  tableAdditionalFilters: {}, // additional table filters received from backend
  additionalFilters: {}, // applied additional table filters
  tableData: {
    header: [],
    body: [],
  },
  pagination: ls.pagination.get(),
  bulkOptions: [],
  bulkExtraOptions: [],
  settings: {},
  search: {},
  createNew: {},
  title: {},
  excelDownload: {},
  iCalDownload: {},
  randomPeopleViewing: {},
  allocationRequest: {},
  randomApplicantsViewing: {},
  legend: [],
  // additional tables
  additionalTables: {},
  tableTemplate: {
    apiPoint: '',
    loading: false,
    sortKey: '',
    searchVal: '',
    stateFilters: {},
    filters: [],
    basicFilters: {},
    tableAdditionalFilters: {},
    additionalFilters: {},
    tableData: {
      header: [],
      body: [],
    },
    pagination: ls.pagination.get(),
    bulkOptions: [],
    bulkExtraOptions: [],
    settings: {},
    search: {},
    createNew: {},
    title: {},
    excelDownload: {},
    iCalDownload: {},
    randomPeopleViewing: {},
    allocationRequest: {},
    randomApplicantsViewing: {},
    legend: [],
  },
  // saved table data on main route/page before going to detail view
  savedTableData: {
    tableRoute: null,
    sortKey: '',
    searchVal: '',
    pagination: {},
    stateFilters: {},
    filters: [],
    basicFilters: {},
    tableAdditionalFilters: {},
    additionalFilters: {},
  },
  currentAdditionalTableRequestData: {},
  isReorderTable: false,
  bulkMailSingleTaskProgress: {
    visible: false,
    id: null,
    completed_tasks: 0,
    total_tasks: 0,
    terminated_tasks: 0,
    failed_tasks: 0,
  },
  bulkMailGroupTasks: [],
  isBackgroundTasksOpen: false, // * whether background tasks dropdown is open
  doesBackgroundTasksExists: false, // * whether ongoing background tasks exist
  selectAllOnPage: false, // * indicates if all rows on the current page are selected
  allEntriesSelected: false, // * whether all entries(all pages) are selected in the table/database
};
